import { hideModal, modalBodyType } from '@/redux/navigationSlice';
import { RootState } from '@/redux/store';
import { Grid, Typography } from '@mui/material';
import { Modal } from '@repo/ui';
import { useDispatch, useSelector } from 'react-redux';
import { AIDataBody } from './aiDataBody';
import { ChangeProspectSubstateBody } from './changeProspectSubstateBody';
import { ChangeTerritoryManagerBody } from './changeTerritoryManagerBody';
import { CloseSessionBody } from './closeSessionBody';
import { ConfirmDocumentChangeBody } from './confirmDocumentChangeBody';
import { DeleteFile } from './deleteFileBody';
import { DismissProspectBody } from './dismissProspectBody';
import { EditRepresentativeEmailBody } from './editRepresentativeEmailBody';
import { UploadFile } from './uploadFileBody';

const bodySelector = (body: modalBodyType) => {
  switch (body) {
    case 'closeSession':
      return <CloseSessionBody />;
    case 'confirmDocumentChange':
      return <ConfirmDocumentChangeBody />;
    case 'changeProspectSubstate':
      return <ChangeProspectSubstateBody />;
    case 'changeTerritoryManager':
      return <ChangeTerritoryManagerBody />;
    case 'editRepresentativeEmail':
      return <EditRepresentativeEmailBody />;
    case 'dismissProspect':
      return <DismissProspectBody />;
    case 'uploadFile':
      return <UploadFile />;
    case 'deleteFile':
      return <DeleteFile />;
    case 'aiData':
      return <AIDataBody />;
    default:
      return <></>;
  }
};

/**
 * Renders a Modal component with title and body based on redux.
 *
 * @return {React.JSX.Element} The rendered Modal component.
 */
export const BackofficeModal = () => {
  const modalData = useSelector((state: RootState) => state.navigationdata.modalData);
  const dispatch = useDispatch();
  const { open, body, title, onClose, maxWidth } = modalData;
  const BodyComponent = bodySelector(body);
  const handleClose = () => {
    dispatch(hideModal());
    onClose?.();
  };
  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
      maxWidth={maxWidth}
    >
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
          py: { xs: 2, md: 4 },
          px: { xs: 2, md: 6 },
        }}
      >
        <Typography variant="h1" sx={{ maxWidth: { xs: '100%', lg: '600px' } }}>
          {title}
        </Typography>
        {BodyComponent}
      </Grid>
    </Modal>
  );
};
